var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.414 3.172A4 4 0 0 1 13.243 2H19a3 3 0 0 1 3 3v5.757a4 4 0 0 1-1.172 2.829l-7.707 7.707a3 3 0 0 1-4.242 0L2.707 15.12a3 3 0 0 1 0-4.242l7.707-7.707ZM13.243 4a2 2 0 0 0-1.415.586l-7.707 7.707a1 1 0 0 0 0 1.414l6.172 6.172a1 1 0 0 0 1.414 0l7.707-7.707A2 2 0 0 0 20 10.757V5a1 1 0 0 0-1-1h-5.757Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.586 10 5 8.586 15.414 19 14 20.414 3.586 10Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: "#777E91"
  })));
};
export default SvgLine;